/* eslint-disable */
export default {
  createCallLog: 'Crea registro chiamate',
  viewInSalesforce: 'Visualizza in Salesforce',
  createLog: 'Crea registro',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
